import React from 'react'
import { FiEdit, FiArrowRight } from 'react-icons/fi'

export const ProfilingItem = ({item}) => {
    const { profile } = {}
    return (
        <li 
            className={`${profile._id === item._id && 'bg-gray'}`} 
         >
            <div className="flex-start">
                <div className="flex-start mr-3" onClick={()=>{}}>
                    <div>{item.type}</div>
                    <p className="name">{item.type}
                        <small className="description ml-2">
                            {item?.sector[0]?.title}
                        </small>
                    </p>
                </div>
            </div>
            <div>
                <FiEdit className="arrow-icon" 
                    onClick={()=> {
                        
                    }}
                />
            </div>
            <div>
                <FiArrowRight className="arrow-icon" 
                />
            </div>
        </li>
    )
}
